import React from 'react'
import { useEffect, useState } from "react";
import { Button, Form, Input, InputNumber, message, Modal, Upload, Table, Switch, Popconfirm } from "antd";
import { PlusOutlined, UploadOutlined, EditOutlined } from "@ant-design/icons";

import Service from "../../service";
import { useDispatch } from "react-redux";
import { hideAuthLoader } from "../../appRedux/actions/Auth";
import TextArea from "antd/lib/input/TextArea";
import "./reward.css";
import "./karma.css";
import EditIcon from '../../assets/images/EditIcon';
import NodataFoundIcon from '../../assets/images/NodataFoundIcon';
import { TABLE_PAGINATION } from "../../constants/tablePagination";


const KarmaAdmin = () => {
  const [form] = Form.useForm();
  const dispatch = useDispatch();

  const [fileList, setFileList] = useState([]);
  const [addRewardModalOpen, setAddRewardModalOpen] = useState(false);
  // const [viewModal, setViewModal] = useState(false);
  const [rewardID, setRewardID] = useState(null);
  const [rewardData, setRewardData] = useState([]);
  const [singleReward, setSingleReward] = useState({});
  const [viewModal, setviewModal] = useState(null);

  // Fetch all rewards
  const getKarmaRewards = async () => {
    try {
      const response = await Service.makeAPICall({
        methodName: Service.getMethod,
        api_url: Service.get_karma_reward_user,
      });

      if (response.status) {
        dispatch(hideAuthLoader());
        setRewardData(response.data.data);
      }
    } catch (error) {
      console.error("Failed to fetch rewards:", error);
    }
  };

  // Fetch a single reward by ID
  const getKarmaRewardById = async (id) => {
    try {
      setRewardID(id);
      const response = await Service.makeAPICall({
        methodName: Service.getMethod,
        api_url: `${Service.get_karma_reward_Id}/${id}`,
      });

      if (response.status) {
        dispatch(hideAuthLoader());
        setSingleReward(response.data.data);

        form.setFieldsValue({
          Title: response.data.data.Title,
          description: response.data.data.description || "No description available",
          karma_amount: response.data.data.karma_amount,
        });

      }
    } catch (error) {
      console.error("Error fetching reward details:", error);
    }
  };

  // Handle form submission (Add / Update)
  const handleOk = async () => {
    try {
      const values = await form.validateFields();
      if (!rewardID && fileList.length === 0) {
        return message.error("Please upload an image.");
      }

      const formData = new FormData();
      formData.append("Title", values.Title);
      formData.append("description", values.description);
      formData.append("karma_amount", values.karma_amount);

      if (fileList.length > 0) {
        formData.append("attachment", fileList[0].originFileObj);
      }

      const apiCall = rewardID
        ? Service.makeAPICall({
          methodName: Service.putMethod,
          api_url: `${Service.update_karma_reward_Id}/${rewardID}`,
          body: formData,
        })
        : Service.makeAPICall({
          methodName: Service.postMethod,
          api_url: Service.add_karma_reward,
          body: formData,
        });

      const response = await apiCall;

      if (response.status) {
        dispatch(hideAuthLoader());
        getKarmaRewards();
        message.success(`Karma reward ${rewardID ? "updated" : "added"} successfully!`);
        form.resetFields();
        setFileList([]);
        setAddRewardModalOpen(false);
        setRewardID(null);
      }
    } catch (error) {
      console.error("Validation Failed:", error);
    }
  };

  // Delete a reward
  const deleteKarmaReward = async (id) => {
    try {
      const response = await Service.makeAPICall({
        methodName: Service.deleteMethod,
        api_url: `${Service.delete_karma_reward_Id}/${id}`,
      });

      if (response.status) {
        dispatch(hideAuthLoader());
        getKarmaRewards();
        message.success("Karma reward deleted successfully.");
      }
    } catch (error) {
      console.error("Failed to delete reward:", error);
    }
  };

  useEffect(() => {
    getKarmaRewards();
  }, []);

  // Table Columns
  const columns = [
    //   {
    //     title: "Image",
    //     dataIndex: "reward_img",
    //     key: "reward_img",
    //     render: (img) => (
    //       <img
    //         src={`${process.env.REACT_APP_API_URL}/uploads/karma_reward-img/${img}`}
    //         alt="Reward"
    //         width={50}
    //         height={50}
    //       />
    //     ),
    //   },
      {
        title: "Title",
        dataIndex: "Title",
        key: "Title",
      },
      {
        title: "Description",
        dataIndex: "description",
        key: "description",
      },
      {
        title: "Waffle Amount",
        dataIndex: "karma_amount",
        key: "karma_amount",
      },
      {
        title: "Waffle Status",
        dataIndex: "karma_status",
        key: "karma_status",
        render: (_, record) => (
          <Popconfirm
          title={`Are you sure you want to ${record.isActive ? "deactivate" : "activate"} this?`}
          okText="Yes"
          cancelText="No"
          onConfirm={() => handleStatusChange(record._id, !record.isActive)} // Toggle status on confirm
        >
          <Switch
            checked={record.isActive} // Check if active
          />
        </Popconfirm>
        )
      },
      {
        title: "Actions",
        key: "actions",
        render: (_, record) => (
          <>
            {/* <EyeOutlined
              style={{ marginRight: 12, color: "#1890ff", cursor: "pointer" }}
              onClick={() => {
                getKarmaRewardById(record._id);
                setviewModal(true);
              }}
            /> */}
            <EditIcon
              style={{ marginRight: 12, color: "#52c41a", cursor: "pointer" }}
              onClick={() => {getKarmaRewardById(record._id);          setAddRewardModalOpen(true);
              }}
            />
          <Popconfirm
            title="Are you sure you want to delete?"
            okText="Yes"
            cancelText="No"
            onConfirm={ () => deleteKarmaReward(record._id) } // Delete if confirmed
          >
            <EditIcon
              style={ { color: "#ff4d4f", cursor: "pointer" } }
            />
          </Popconfirm>
        </>
      ),
    },
 
  ];


  const handleStatusChange = async (id, checked) => {
    const newStatus = checked ? "true" : "false";

    try {
      const response = await Service.makeAPICall({
        methodName: Service.putMethod,
        api_url: `${Service.update_karma_reward_Id}/${id}`,
        body: { isActive: newStatus },
      });

      if (response.status) {
        message.success("Status updated successfully!");
        getKarmaRewards(); // Refresh data
      } else {
        message.error("Failed to update status.");
      }
    } catch (error) {
      console.error("Error updating status:", error);
      message.error("Error updating status.");
    }
  };

  return (
    <div className="rewards-container karma-wrapper">
      {/* Header with Add Reward button */ }
      <div className="header-container" style={ { display: 'flex', justifyContent: 'space-between' } } >
        <h2 className="rewards-title"> Reward Admin</h2>
        <Button type="primary" icon={<PlusOutlined />} onClick={ () => setAddRewardModalOpen(true) }>
          Reward
        </Button>
      </div>

    {/* Rewards Table */}
    <Table    locale={ { emptyText: <NodataFoundIcon/> } } dataSource={rewardData} columns={columns} rowKey="_id" pagination={{ ...TABLE_PAGINATION }}  />

      {/* Add / Edit Reward Modal */ }
      <Modal
        className='redeem-modal'
        title={ rewardID ? "Update Waffle Reward" : "Add Waffle Reward" }
        open={ addRewardModalOpen }
        onCancel={ () => {
          setAddRewardModalOpen(false);
          setRewardID(null);
          form.resetFields();
        } }
        footer={ null }
      >
        <Form form={ form } layout="vertical" onFinish={ handleOk }>
          <Form.Item name="Title" label="Title" rules={ [{ required: true }] }>
            <Input placeholder="Enter title" />
          </Form.Item>

          <Form.Item name="description" label="Description" rules={ [{ required: true }] }>
            <TextArea rows={ 3 } placeholder="Enter description" />
          </Form.Item>

          <Form.Item name="karma_amount" label="Waffle Amount" rules={ [{ required: true }] }>
            <InputNumber min={ 1 } style={ { width: "100%" } } placeholder="Enter Waffle amount" />
          </Form.Item>

          <Form.Item label="Reward Image">
            <Upload beforeUpload={ () => false } fileList={ fileList } onChange={ ({ fileList }) => setFileList(fileList) }>
              <Button icon={ <UploadOutlined /> }>Upload Image</Button>
            </Upload>
          </Form.Item>

          <Button type="primary" className='redeem-button' htmlType="submit">{ rewardID ? "Update" : "Add" } Reward</Button>
          <Button type="text" className='ant-delete' onClick={ () => setAddRewardModalOpen(false) }>Cancel</Button>

        </Form>
      </Modal>
      <Modal
        title="Reward Description"
        open={ viewModal }
        onCancel={ () => { setviewModal(false) } }
        footer={ false }
      >
        <Form form={ form } layout="vertical">
          <Form.Item label="Description" name="description">
            <TextArea rows={ 4 } disabled />
          </Form.Item>
        </Form>  {/*  */ }

      </Modal>
    </div>
  )
}

export default KarmaAdmin
